// combineErrorList

import {forOwn, isString} from 'lodash';

export function combineYupErrors(list: string[], errors: {} | string) {
   if (isString(errors)) {
      list.push(errors);
      return;
   }
   forOwn(errors, (e) => combineYupErrors(list, e));
}
